<template>
  <v-row justify="start">
    <v-dialog
      v-model="dialogRegister"
      @click:outside="$emit('close')"
      scrollable
      max-width="500px"
    >
      <v-card class="rounded-max">
        <v-toolbar dense flat>
          <div></div>
          <v-spacer></v-spacer>
          <h3>Registrasi</h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-1">
          <v-container>
            <v-card class="pa-2" flat>
              <div>
                <v-row>
                  <v-col cols="12" md="12"
                    ><v-text-field
                      v-model="name"
                      :error-messages="objErr.nama"
                      hide-details="auto"
                      label="Nama lengkap"
                      required
                      dense
                      background-color="#E9E5EB"
                      outlined
                    ></v-text-field
                  ></v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-radio-group
                      v-model="gender"
                      row
                      hide-details="auto"
                      class="mt-0"
                    >
                      <v-radio
                        color="purple"
                        label="Laki-laki"
                        value="L"
                      ></v-radio>
                      <v-radio
                        color="purple"
                        label="Perempuan"
                        value="P"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12"
                    ><v-text-field
                      v-model="no_hp"
                      hide-details="auto"
                      label="No Hp"
                      :error-messages="objErr.no_telp"
                      required
                      background-color="#E9E5EB"
                      outlined
                      dense
                    ></v-text-field
                  ></v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-menu
                      v-model="calendar1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="birth_date"
                          label="Tanggal Lahir"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          hide-details
                          background-color="#E9E5EB"
                          :error-messages="objErr.tgl_lahir"
                          outlined
                          dense
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="birth_date"
                        @input="calendar1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-radio-group
                      v-model="profesi"
                      row
                      :error-messages="objErr.profesi"
                      hide-details="auto"
                      class="mt-0"
                    >
                      <v-radio
                        label="Siswa/Mahasiswa"
                        value="mahasiswa"
                        color="purple"
                      ></v-radio>
                      <v-radio
                        label="Pekerja"
                        color="purple"
                        value="pekerja"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12"
                    ><v-text-field
                      v-model="email"
                      hide-details="auto"
                      label="Email"
                      :error-messages="objErr.email"
                      required
                      outlined
                      background-color="#E9E5EB"
                      dense
                    ></v-text-field
                  ></v-col>
                </v-row>
                <v-row>
                  <v-col cols="12"
                    ><v-text-field
                      v-model="password"
                      hide-details="auto"
                      label="Password"
                      :error-messages="objErr.password"
                      required
                      outlined
                      dense
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show1 ? 'text' : 'password'"
                      background-color="#E9E5EB"
                      @click:append="show1 = !show1"
                    ></v-text-field>
                    <p
                      style="line-height: 1; font-size: small"
                      class="ma-0 mt-1"
                      v-if="!objErr.password"
                    >
                      *Harus terdiri dari 6 samapai 32 karakter dengan
                      setidaknya terdapat 1 huruf kapital, angka, dan simbol
                      (@$!%*#?&).
                    </p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12"
                    ><v-text-field
                      v-model="repassword"
                      :error-messages="objErr.repassword"
                      hide-details="auto"
                      label="Ulangi Password"
                      required
                      dense
                      background-color="#E9E5EB"
                      outlined
                      :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show2 ? 'text' : 'password'"
                      @click:append="show2 = !show2"
                      @blur="isPwdSame"
                    ></v-text-field>
                    <p
                      style="line-height: 1; font-size: small"
                      class="ma-0 mt-1"
                    ></p>
                  </v-col>
                </v-row>
                <div class="py-3">
                  <v-btn
                    rounded
                    block
                    v-if="!loading"
                    class="text-capitalize"
                    depressed
                    color="#23003a"
                    dark
                    @click="register"
                    >Daftar</v-btn
                  >
                  <v-btn
                    rounded
                    block
                    v-if="loading"
                    class="text-capitalize"
                    depressed
                    color="#23003a"
                    dark
                    @click="register"
                  >
                    <v-progress-circular
                      size="20"
                      class="mr-2"
                      indeterminate
                    ></v-progress-circular
                    >Loading</v-btn
                  >
                </div>
                <PopupError
                  v-bind:dialogErr="dialogErr"
                  @close="dialogErr = false"
                />
              </div>
            </v-card>
          </v-container>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import popupError from "./popupError.vue";
export default {
  components: { popupError },
  name: "dialogRegister",

  props: ["dialogRegister"],
  computed: {
    ...mapState({
      list_journey: (state) => state.list_journey,
    }),
  },
  data() {
    return {
      filteredList: [],
      name: "",
      password: "",
      repassword: "",
      email: "",
      no_hp: "",
      birth_date: "",
      gender: "",
      profesi: "",
      calendar1: false,
      emailErr: null,
      pwdErr: null,
      answeredJourney: null,
      loading: false,
      show1: false,
      show2: false,
      dialogErr: false,
      objErr: {
        nama: "",
        no_telp: "",
        tgl_lahir: "",
        profesi: "",
        email: "",
        password: "",
        repassword: "",
      },
    };
  },
  mounted() {
    this.preparePostJourney();
  },
  methods: {
    preparePostJourney() {
      let completed = JSON.parse(localStorage.getItem("completed"));
      let items = [];
      completed.forEach((el) => {
        let item = JSON.parse(
          localStorage.getItem(el.journey.toLowerCase().replace(/\s/g, ""))
        ).answer;
        items.push({ id: el.id, jawaban: item.jawaban });
      });
      // console.log(items);
      this.answeredJourney = items;
    },
    isPwdSame() {
      if (this.password !== this.repassword) {
        this.objErr.repassword = "Passowrd Tidak sama!";
      } else {
        this.objErr.repassword = "";
      }
    },
    register() {
      let data = {
        nama: this.name,
        jenkel: this.gender,
        no_telp: this.no_hp,
        tgl_lahir: this.birth_date,
        profesi: this.profesi,
        email: this.email,
        password: this.password,
      };
      this.loading = true;
      this.$store
        .dispatch("register", data)
        .then((data) => {
          this.postJourney(data.token);
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          let errors = err.response.data.error;
          for (let e in errors) {
            this.objErr[e] = errors[e];
          }
        });
    },
    postJourney(token) {
      console.log(token);
      this.answeredJourney.forEach((item) => {
        let data = {
          id: item.id,
          body: { jawaban: item.jawaban },
          token: token,
        };
        this.$store
          .dispatch("postJourney", data)
          .then((data) => {
            this.loading = false;
            this.$router.push("/journey/thanks");
            console.log(data);
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
  },
};
</script>
<style scoped>
.no_decoration {
  text-decoration: none;
}
.img-journey {
  height: 50px;
}
.rounded-img {
  height: 75px;
  width: 75px;
  background: white;
  border-radius: 50%;
}
.decoration {
  text-decoration: none;
}
.v-text-field--outlined >>> fieldset {
  border-color: #e9e5eb;
}
</style>
